import TeamsRegistrationComponent from '../components/TeamsRegistrationComponent';

export default function RegisterTeams() {
    return (
        <div className="analytics-container teams-registrations">
            <TeamsRegistrationComponent />
        </div>
    );
}

